'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ShoppingCart = function ShoppingCart(props) {
  return React__default["default"].createElement("svg", _objectSpread({
    width: "816",
    height: "446",
    viewBox: "0 0 816 446",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417 13V19.3333C418.105 19.3333 419 18.4379 419 17.3333V15H421C422.105 15 423 14.1046 423 13H417ZM427 13C427 14.1046 427.895 15 429 15H437C438.105 15 439 14.1046 439 13H427ZM443 13C443 14.1046 443.895 15 445 15H453C454.105 15 455 14.1046 455 13H443ZM459 13C459 14.1046 459.895 15 461 15H469C470.105 15 471 14.1046 471 13H459ZM475 13C475 14.1046 475.895 15 477 15H485C486.105 15 487 14.1046 487 13H475ZM491 13C491 14.1046 491.895 15 493 15H501C502.105 15 503 14.1046 503 13H491ZM507 13C507 14.1046 507.895 15 509 15H511V17.3333C511 18.4379 511.895 19.3333 513 19.3333V13H507ZM513 24C511.895 24 511 24.8954 511 26V34.6667C511 35.7712 511.895 36.6667 513 36.6667V24ZM513 41.3333C511.895 41.3333 511 42.2288 511 43.3333V52C511 53.1046 511.895 54 513 54V41.3333ZM513 58.6667C511.895 58.6667 511 59.5621 511 60.6667V63H509C507.895 63 507 63.8954 507 65H513V58.6667ZM503 65C503 63.8954 502.105 63 501 63H493C491.895 63 491 63.8954 491 65H503ZM487 65C487 63.8954 486.105 63 485 63H477C475.895 63 475 63.8954 475 65H487ZM471 65C471 63.8954 470.105 63 469 63H461C459.895 63 459 63.8954 459 65H471ZM455 65C455 63.8954 454.105 63 453 63H445C443.895 63 443 63.8954 443 65H455ZM439 65C439 63.8954 438.105 63 437 63H429C427.895 63 427 63.8954 427 65H439ZM423 65C423 63.8954 422.105 63 421 63H419V60.6667C419 59.5621 418.105 58.6667 417 58.6667V65H423ZM417 54C418.105 54 419 53.1046 419 52V43.3333C419 42.2288 418.105 41.3333 417 41.3333V54ZM417 36.6667C418.105 36.6667 419 35.7712 419 34.6667V26C419 24.8954 418.105 24 417 24V36.6667Z",
    fill: "#757575"
  }), React__default["default"].createElement("rect", {
    y: "279",
    width: "816",
    height: "167",
    fill: "url(#paint0_radial)"
  }), React__default["default"].createElement("rect", {
    opacity: "0.4",
    x: "108",
    y: "279",
    width: "600",
    height: "2",
    rx: "1",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.5 62H520.188C520.188 60.8954 519.292 60 518.188 60H517.483L517.975 58.8012C518.395 57.7794 517.906 56.611 516.885 56.1915L514.5 62ZM518.615 51.9752C519.637 52.3946 520.806 51.9064 521.225 50.8845L524.475 42.9679C524.895 41.9461 524.406 40.7777 523.385 40.3582L518.615 51.9752ZM525.115 36.1418C526.137 36.5613 527.306 36.073 527.725 35.0512L530.975 27.1345C531.395 26.1127 530.906 24.9443 529.885 24.5248L525.115 36.1418ZM531.615 20.3085C532.637 20.728 533.806 20.2397 534.225 19.2179L535.341 16.5H538C539.105 16.5 540 15.6046 540 14.5H534L531.615 20.3085ZM544 14.5C544 15.6046 544.895 16.5 546 16.5H554C555.105 16.5 556 15.6046 556 14.5H544ZM560 14.5C560 15.6046 560.895 16.5 562 16.5H565.172L567.148 18.4767C567.929 19.2578 569.196 19.2578 569.977 18.4767L566 14.5H560ZM572.273 20.7733C571.492 21.5543 571.492 22.8207 572.273 23.6017L577.398 28.7267C578.179 29.5078 579.446 29.5078 580.227 28.7267L572.273 20.7733ZM582.523 31.0233C581.742 31.8043 581.742 33.0707 582.523 33.8517L584.082 35.4109L583.073 37.5074C582.594 38.5026 583.012 39.6978 584.007 40.177L586.5 35L582.523 31.0233ZM582.493 43.323C581.497 42.8438 580.302 43.2621 579.823 44.2574L576.573 51.0074C576.094 52.0026 576.512 53.1978 577.507 53.677L582.493 43.323ZM575.993 56.823C574.997 56.3438 573.802 56.7621 573.323 57.7574L572.243 60H569.812C568.708 60 567.812 60.8954 567.812 62H573.5L575.993 56.823ZM564.438 62C564.438 60.8954 563.542 60 562.438 60H555.062C553.958 60 553.062 60.8954 553.062 62H564.438ZM549.688 62C549.688 60.8954 548.792 60 547.688 60H540.312C539.208 60 538.312 60.8954 538.312 62H549.688ZM534.938 62C534.938 60.8954 534.042 60 532.938 60H525.562C524.458 60 523.562 60.8954 523.562 62H534.938Z",
    fill: "#757575"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346 1C346.552 1 347 1.44772 347 2V5.71875C347 6.27103 346.552 6.71875 346 6.71875C345.448 6.71875 345 6.27103 345 5.71875V2C345 1.44772 345.448 1 346 1ZM346 12.1562C346.552 12.1562 347 12.604 347 13.1562V20.5938C347 21.146 346.552 21.5938 346 21.5938C345.448 21.5938 345 21.146 345 20.5938V13.1562C345 12.604 345.448 12.1562 346 12.1562ZM346 27.0312C346.552 27.0312 347 27.479 347 28.0312V35.4688C347 36.021 346.552 36.4688 346 36.4688C345.448 36.4688 345 36.021 345 35.4688V28.0312C345 27.479 345.448 27.0312 346 27.0312ZM346 41.9062C346.552 41.9062 347 42.354 347 42.9062V50.3438C347 50.896 346.552 51.3438 346 51.3438C345.448 51.3438 345 50.896 345 50.3438V42.9062C345 42.354 345.448 41.9062 346 41.9062ZM346 56.7812C346.552 56.7812 347 57.229 347 57.7812V61.5C347 62.0523 346.552 62.5 346 62.5C345.448 62.5 345 62.0523 345 61.5V57.7812C345 57.229 345.448 56.7812 346 56.7812Z",
    fill: "#757575"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298 41V46.1875C299.105 46.1875 300 45.2921 300 44.1875V41.922L302.299 39.9582C303.139 39.2408 303.238 37.9784 302.521 37.1385L298 41ZM305.479 34.6115C306.197 35.4514 307.459 35.5506 308.299 34.8332L314.299 29.7082C315.139 28.9908 315.238 27.7284 314.521 26.8885L305.479 34.6115ZM317.479 24.3615C318.197 25.2014 319.459 25.3006 320.299 24.5832L326.299 19.4582C327.139 18.7408 327.238 17.4784 326.521 16.6385L317.479 24.3615ZM329.479 14.1115C330.197 14.9514 331.459 15.0506 332.299 14.3332L338.299 9.20825C339.139 8.49084 339.238 7.22841 338.521 6.38853L329.479 14.1115ZM341.479 3.86147C342.197 4.70136 343.459 4.80065 344.299 4.08325L346.191 2.46725L348.275 3.75244C349.216 4.33213 350.448 4.03985 351.027 3.09962L346 0L341.479 3.86147ZM354.273 5.10038C353.693 6.04061 353.985 7.27275 354.925 7.85244L361.575 11.9524C362.516 12.5321 363.748 12.2399 364.327 11.2996L354.273 5.10038ZM367.573 13.3004C366.993 14.2406 367.285 15.4727 368.225 16.0524L374.875 20.1524C375.816 20.7321 377.048 20.4399 377.627 19.4996L367.573 13.3004ZM380.873 21.5004C380.293 22.4406 380.585 23.6727 381.525 24.2524L388.175 28.3524C389.116 28.9321 390.348 28.6399 390.927 27.6996L380.873 21.5004ZM394.173 29.7004C393.593 30.6406 393.885 31.8727 394.825 32.4524L401.475 36.5524C402.416 37.1321 403.648 36.8399 404.227 35.8996L394.173 29.7004ZM407.473 37.9004C406.893 38.8406 407.185 40.0727 408.125 40.6524L410.5 42.1165V44.1875C410.5 45.2921 411.395 46.1875 412.5 46.1875V41L407.473 37.9004ZM412.5 48.5625C411.395 48.5625 410.5 49.4579 410.5 50.5625V56.9375C410.5 58.0421 411.395 58.9375 412.5 58.9375V48.5625ZM412.5 61.3125C411.395 61.3125 410.5 62.2079 410.5 63.3125V64.5H408.411C407.306 64.5 406.411 65.3954 406.411 66.5H412.5V61.3125ZM402.232 66.5C402.232 65.3954 401.337 64.5 400.232 64.5H392.054C390.949 64.5 390.054 65.3954 390.054 66.5H402.232ZM385.875 66.5C385.875 65.3954 384.98 64.5 383.875 64.5H375.696C374.592 64.5 373.696 65.3954 373.696 66.5H385.875ZM369.518 66.5C369.518 65.3954 368.622 64.5 367.518 64.5H359.339C358.235 64.5 357.339 65.3954 357.339 66.5H369.518ZM353.161 66.5C353.161 65.3954 352.265 64.5 351.161 64.5H342.982C341.878 64.5 340.982 65.3954 340.982 66.5H353.161ZM336.804 66.5C336.804 65.3954 335.908 64.5 334.804 64.5H326.625C325.52 64.5 324.625 65.3954 324.625 66.5H336.804ZM320.446 66.5C320.446 65.3954 319.551 64.5 318.446 64.5H310.268C309.163 64.5 308.268 65.3954 308.268 66.5H320.446ZM304.089 66.5C304.089 65.3954 303.194 64.5 302.089 64.5H300V63.3125C300 62.2079 299.105 61.3125 298 61.3125V66.5H304.089ZM298 58.9375C299.105 58.9375 300 58.0421 300 56.9375V50.5625C300 49.4579 299.105 48.5625 298 48.5625V58.9375Z",
    fill: "#757575"
  }), React__default["default"].createElement("g", {
    opacity: "0.24",
    filter: "url(#filter0_f)"
  }, React__default["default"].createElement("path", {
    d: "M285 283C285 281.895 285.895 281 287 281H561C562.105 281 563 281.895 563 283V283.839C563 284.557 562.615 285.22 561.992 285.576L545.5 295L528.276 289.095C528.093 289.032 527.902 288.996 527.708 288.988L429 285L330.259 288.99C330.087 288.996 329.917 289.026 329.752 289.076L311.168 294.795C310.735 294.928 310.271 294.91 309.849 294.745L286.27 285.498C285.504 285.198 285 284.459 285 283.636V283Z",
    fill: "#00314A"
  })), React__default["default"].createElement("path", {
    d: "M235.5 25.5L292 46C300 176 300 189 300 189C288 207.5 282.726 242 302 242C327 242 451.5 242 559 242",
    stroke: "#3387CD",
    strokeWidth: "12",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("mask", {
    id: "path-9-inside-1",
    fill: "white"
  }, React__default["default"].createElement("path", {
    d: "M552.73 190H301.581C297.33 190 293.821 186.675 293.592 182.43L287.454 68.4301C287.207 63.8495 290.855 60 295.442 60H580.792C585.985 60 589.801 64.8701 588.56 69.9122L560.499 183.912C559.619 187.487 556.412 190 552.73 190Z"
  })), React__default["default"].createElement("path", {
    d: "M552.73 190H301.581C297.33 190 293.821 186.675 293.592 182.43L287.454 68.4301C287.207 63.8495 290.855 60 295.442 60H580.792C585.985 60 589.801 64.8701 588.56 69.9122L560.499 183.912C559.619 187.487 556.412 190 552.73 190Z",
    fill: "#3387CD",
    stroke: "#3387CD",
    strokeWidth: "28",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#path-9-inside-1)"
  }), React__default["default"].createElement("path", {
    d: "M304.429 84.4076C304.196 79.8352 307.84 76 312.419 76H561.703C566.923 76 570.745 80.9191 569.455 85.9775L548.536 167.977C547.632 171.521 544.441 174 540.785 174H316.602C312.342 174 308.83 170.662 308.613 166.408L304.429 84.4076Z",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "309",
    y: "64",
    width: "96",
    height: "4",
    rx: "2",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "429",
    y: "64",
    width: "40",
    height: "4",
    rx: "2",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "493",
    y: "64",
    width: "72",
    height: "4",
    rx: "2",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "293",
    y: "92",
    width: "288",
    height: "6",
    rx: "3",
    fill: "#3387CD"
  }), React__default["default"].createElement("rect", {
    x: "327.518",
    y: "189",
    width: "120",
    height: "6",
    rx: "3",
    transform: "rotate(-93 327.518 189)",
    fill: "#3387CD"
  }), React__default["default"].createElement("rect", {
    x: "357.695",
    y: "189",
    width: "120",
    height: "6",
    rx: "3",
    transform: "rotate(-92 357.695 189)",
    fill: "#3387CD"
  }), React__default["default"].createElement("rect", {
    x: "385.785",
    y: "189",
    width: "120",
    height: "6",
    rx: "3",
    transform: "rotate(-91 385.785 189)",
    fill: "#3387CD"
  }), React__default["default"].createElement("rect", {
    x: "411.785",
    y: "189",
    width: "120",
    height: "6",
    rx: "3",
    transform: "rotate(-90 411.785 189)",
    fill: "#3387CD"
  }), React__default["default"].createElement("rect", {
    x: "437.785",
    y: "189",
    width: "120",
    height: "6",
    rx: "3",
    transform: "rotate(-89 437.785 189)",
    fill: "#3387CD"
  }), React__default["default"].createElement("rect", {
    x: "465.879",
    y: "189",
    width: "120",
    height: "6",
    rx: "3",
    transform: "rotate(-88 465.879 189)",
    fill: "#3387CD"
  }), React__default["default"].createElement("rect", {
    x: "496.062",
    y: "188.836",
    width: "120",
    height: "6",
    rx: "3",
    transform: "rotate(-87 496.062 188.836)",
    fill: "#3387CD"
  }), React__default["default"].createElement("rect", {
    x: "528.334",
    y: "189",
    width: "120",
    height: "6",
    rx: "3",
    transform: "rotate(-86 528.334 189)",
    fill: "#3387CD"
  }), React__default["default"].createElement("rect", {
    x: "293",
    y: "122",
    width: "280",
    height: "6",
    rx: "3",
    fill: "#3387CD"
  }), React__default["default"].createElement("rect", {
    x: "294",
    y: "152",
    width: "270",
    height: "6",
    rx: "3",
    fill: "#3387CD"
  }), React__default["default"].createElement("path", {
    d: "M227.736 22.5175C229.248 18.3657 233.838 16.225 237.99 17.7362L266.181 27.9968C267.219 28.3745 267.754 29.5222 267.376 30.5602L263.272 41.8365C262.894 42.8745 261.747 43.4096 260.709 43.0318L232.518 32.7712C228.366 31.2601 226.225 26.6694 227.736 22.5175Z",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    d: "M227.736 22.5175C229.248 18.3657 233.838 16.225 237.99 17.7362L266.181 27.9968C267.219 28.3745 267.754 29.5222 267.376 30.5602L263.272 41.8365C262.894 42.8745 261.747 43.4096 260.709 43.0318L232.518 32.7712C228.366 31.2601 226.225 26.6694 227.736 22.5175Z",
    stroke: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "575",
    y: "58",
    width: "16",
    height: "16",
    rx: "4",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "575",
    y: "58",
    width: "16",
    height: "16",
    rx: "4",
    stroke: "#0069C0"
  }), React__default["default"].createElement("circle", {
    cx: "312",
    cy: "272",
    r: "13",
    fill: "#EDF6FE",
    stroke: "#0069C0",
    strokeWidth: "6"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.929 254C302.389 254 300.492 256.338 301.015 258.824L303.999 273H304.061C304.553 276.946 307.92 280 311.999 280C316.079 280 319.445 276.946 319.938 273H319.999L322.984 258.824C323.507 256.338 321.61 254 319.07 254H304.929Z",
    fill: "#3387CD"
  }), React__default["default"].createElement("circle", {
    cx: "312",
    cy: "272",
    r: "4",
    fill: "#EDF6FE"
  }), React__default["default"].createElement("rect", {
    x: "308",
    y: "248",
    width: "8",
    height: "6",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "302",
    y: "182",
    width: "128",
    height: "4",
    rx: "2",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "301",
    y: "244",
    width: "256",
    height: "4",
    rx: "2",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "303",
    y: "256",
    width: "18",
    height: "4",
    rx: "2",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "446",
    y: "182",
    width: "104",
    height: "4",
    rx: "2",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "310",
    y: "268",
    width: "4",
    height: "4",
    rx: "2",
    fill: "white"
  }), React__default["default"].createElement("circle", {
    cx: "544",
    cy: "272",
    r: "13",
    fill: "#EDF6FE",
    stroke: "#0069C0",
    strokeWidth: "6"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.929 254C534.389 254 532.492 256.338 533.015 258.824L535.999 273H536.061C536.553 276.946 539.92 280 543.999 280C548.079 280 551.445 276.946 551.938 273H551.999L554.984 258.824C555.507 256.338 553.61 254 551.07 254H536.929Z",
    fill: "#3387CD"
  }), React__default["default"].createElement("circle", {
    cx: "544",
    cy: "272",
    r: "4",
    fill: "#EDF6FE"
  }), React__default["default"].createElement("rect", {
    x: "540",
    y: "248",
    width: "8",
    height: "6",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "542",
    y: "268",
    width: "4",
    height: "4",
    rx: "2",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "234.367",
    y: "20",
    width: "24",
    height: "4",
    rx: "2",
    transform: "rotate(20 234.367 20)",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "579",
    y: "60",
    width: "8",
    height: "4",
    rx: "2",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "535",
    y: "256",
    width: "18",
    height: "4",
    rx: "2",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M534.33 15.2576C534.74 14.8876 535.372 14.92 535.742 15.33L538.055 17.8925C538.425 18.3026 538.392 18.9349 537.982 19.3049C537.572 19.6749 536.94 19.6425 536.57 19.2325L534.258 16.67C533.888 16.26 533.92 15.6276 534.33 15.2576ZM541.268 22.9451C541.678 22.5751 542.31 22.6075 542.68 23.0175L547.305 28.1425C547.675 28.5526 547.642 29.1849 547.232 29.5549C546.822 29.9249 546.19 29.8925 545.82 29.4825L541.195 24.3575C540.825 23.9475 540.858 23.3151 541.268 22.9451ZM550.518 33.1951C550.928 32.8251 551.56 32.8575 551.93 33.2675L553.932 35.4856L557.343 35.3755C557.895 35.3577 558.357 35.7908 558.374 36.3428C558.392 36.8948 557.959 37.3567 557.407 37.3745L554.172 37.4789L553.046 40.1396C552.831 40.6483 552.244 40.8862 551.735 40.671C551.227 40.4558 550.989 39.869 551.204 39.3604L552.331 36.697L550.445 34.6075C550.075 34.1975 550.108 33.5651 550.518 33.1951ZM585.499 35.4678C585.517 36.0198 585.084 36.4817 584.532 36.4995L580.657 36.6245C580.105 36.6423 579.643 36.2092 579.626 35.6572C579.608 35.1053 580.041 34.6433 580.593 34.6255L584.468 34.5005C585.02 34.4827 585.482 34.9158 585.499 35.4678ZM573.874 35.8428C573.892 36.3948 573.459 36.8567 572.907 36.8745L565.157 37.1245C564.605 37.1423 564.143 36.7092 564.126 36.1572C564.108 35.6053 564.541 35.1433 565.093 35.1255L572.843 34.8755C573.395 34.8577 573.857 35.2908 573.874 35.8428ZM549.765 45.329C550.273 45.5442 550.511 46.131 550.296 46.6396L547.546 53.1396C547.331 53.6483 546.744 53.8862 546.235 53.671C545.727 53.4558 545.489 52.869 545.704 52.3604L548.454 45.8604C548.669 45.3517 549.256 45.1138 549.765 45.329ZM544.265 58.329C544.773 58.5442 545.011 59.131 544.796 59.6396L543.421 62.8896C543.206 63.3983 542.619 63.6362 542.11 63.421C541.602 63.2058 541.364 62.619 541.579 62.1104L542.954 58.8604C543.169 58.3517 543.756 58.1138 544.265 58.329Z",
    fill: "#757575"
  }), React__default["default"].createElement("defs", null, React__default["default"].createElement("filter", {
    x: "273",
    y: "269",
    width: "302",
    height: "38",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React__default["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "6",
    result: "effect1_foregroundBlur"
  })), React__default["default"].createElement("radialGradient", {
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(408 279) rotate(90) scale(146 509.128)"
  }, React__default["default"].createElement("stop", {
    stopColor: "#2196F3",
    stopOpacity: "0.08"
  }), React__default["default"].createElement("stop", {
    offset: "1",
    stopColor: "#C4C4C4",
    stopOpacity: "0"
  }))));
};

module.exports = ShoppingCart;
